import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Send, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TOPICS = [
  "Raising capital",
  "Exit strategy",
  "Market entry & competition",
  "Strategic partnership",
  "General inquiry",
];

export const ContactForm = ({ compact = false }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    company: "",
    topic: TOPICS[0],
    message: "",
  });
  const [sending, setSending] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      await axios.post(`${API}/contact`, form);
      toast.success("Message sent. Roy will get back to you directly.");
      setForm({ name: "", email: "", company: "", topic: TOPICS[0], message: "" });
    } catch (err) {
      toast.error("Something went wrong sending your message. Please email Roy directly.");
    } finally {
      setSending(false);
    }
  };

  return (
    <form
      data-testid="contact-form"
      onSubmit={submit}
      className={`grid gap-4 ${compact ? "" : "sm:grid-cols-2"}`}
    >
      <input
        data-testid="contact-name-input"
        className="field"
        placeholder="Your name *"
        value={form.name}
        onChange={set("name")}
        required
        minLength={2}
      />
      <input
        data-testid="contact-email-input"
        className="field"
        type="email"
        placeholder="Your email *"
        value={form.email}
        onChange={set("email")}
        required
      />
      <input
        data-testid="contact-company-input"
        className="field"
        placeholder="Company"
        value={form.company}
        onChange={set("company")}
      />
      <select
        data-testid="contact-topic-select"
        className="field"
        value={form.topic}
        onChange={set("topic")}
      >
        {TOPICS.map((t) => (
          <option key={t} value={t}>
            {t}
          </option>
        ))}
      </select>
      <textarea
        data-testid="contact-message-input"
        className="field sm:col-span-2"
        rows={compact ? 4 : 6}
        placeholder="What are you building, raising, or trying to win? *"
        value={form.message}
        onChange={set("message")}
        required
        minLength={10}
      />
      <div className="sm:col-span-2">
        <button
          data-testid="contact-submit-btn"
          type="submit"
          disabled={sending}
          className="btn-gold w-full sm:w-auto disabled:opacity-60"
        >
          {sending ? <Loader2 size={16} className="animate-spin" /> : <Send size={16} />}
          {sending ? "Sending…" : "Send Message"}
        </button>
      </div>
    </form>
  );
};
